import { render, staticRenderFns } from "./Aplicativo.vue?vue&type=template&id=670e682a&scoped=true"
import script from "./Aplicativo.vue?vue&type=script&lang=js"
export * from "./Aplicativo.vue?vue&type=script&lang=js"
import style0 from "./Aplicativo.vue?vue&type=style&index=0&id=670e682a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e682a",
  null
  
)

export default component.exports